import { getAccessToken } from '@nexus/supabase';

export interface MemorySection {
  /** Mem0 category key — the frontend translates it to a heading. */
  category: string;
  /** English default heading (used when no translation exists). */
  title: string;
  items: string[];
}

export interface MemoryDocument {
  sections: MemorySection[];
  updatedAt: string | null;
}

/**
 * Fetch the authenticated user's memories from the Mem0-backed edge function.
 * Mirrors fetchMyEntitlements: the caller passes its app-configured auth
 * backend base URL; the user is resolved server-side from the bearer token.
 */
export async function getMemory(baseUrl: string): Promise<MemoryDocument> {
  const token = await getAccessToken();
  if (!token) throw new Error('No authenticated session');

  const response = await fetch(`${baseUrl}/memories`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error(`Memory request failed (${response.status})`);

  const data = (await response.json()) as Partial<MemoryDocument>;
  return { sections: data.sections ?? [], updatedAt: data.updatedAt ?? null };
}
